import { useContext } from 'react';
import { Button, Box, Flex, Text, useDisclosure } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import PassesListFilter from './PassesListFilter';
import QuickFilters from './QuickFilters';
import useOrganizationStatus from '../../../hooks/useOrganisationStatus';
import { CustomPassIdSearchBar } from './CustomPassIdSearchBar';
import PassesBatchNavigationSwitchField from '../batches/PassesBatchNavigationSwitchField';
import PageHeadingWithTrialProgress from '../dashboard/PageHeadingWithTrialProgress';
import { useListPassTemplatesQuery } from '../../../store/redux/api/templateApi';
import { MeContext } from '../../../context/MeContext';
import type { MeContextState } from '../../../store/types/account';
import { useIsReadOnly } from '../../../hooks/useIsReadOnly';
import LockedActionButton from '../../common/LockedActionButton';

function PassesListHeader() {
  const { shouldRender } = useOrganizationStatus();
  const isReadOnly = useIsReadOnly();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const meCtx = useContext(MeContext) as { state: MeContextState };
  const entityId = meCtx.state.filterEntity?.uuid;
  const { data: templatesData, isSuccess } = useListPassTemplatesQuery({
    entityId,
    skipImages: true,
    fields: 'name',
  });
  const hasNoTemplates = isSuccess && (templatesData?.data?.length ?? 0) === 0;

  return (
    <>
      <PageHeadingWithTrialProgress title="Passes" />
      <Text fontSize="18px" mb="20px">
        Issue, search and manage passes created from templates.
      </Text>
      <PassesBatchNavigationSwitchField />
      {shouldRender && (
        <Box w="full" mb="30px">
          <Flex flexDirection={'row'} w={'80%'} alignItems={'center'} mb="16px">
            <CustomPassIdSearchBar />
          </Flex>
          <Flex
            w="full"
            flexDirection={{ base: 'column-reverse', sm: 'row' }}
            justify="space-between"
            alignItems="center"
          >
            <QuickFilters
              onOpenMoreFilters={onOpen}
              isMoreFiltersOpen={isOpen}
            />
            <Flex
              gap={{ base: '10px', sm: '0px' }}
              alignItems="flex-end"
              justifyContent="flex-end"
              flexWrap="wrap"
            >
              {isReadOnly ? (
                <LockedActionButton
                  reason="issue-passes"
                  mr={{ base: '0px', sm: '10px' }}
                  px={{ base: '20px', sm: '20px' }}
                  size="sm"
                >
                  Create new pass
                </LockedActionButton>
              ) : (
                <Button
                  mr={{ base: '0px', sm: '10px' }}
                  px={{ base: '20px', sm: '20px' }}
                  aria-label="Create new pass"
                  size="sm"
                  as={hasNoTemplates ? undefined : RouterLink}
                  to={hasNoTemplates ? undefined : '/passes/create'}
                  disabled={hasNoTemplates}
                >
                  Create new pass
                </Button>
              )}
            </Flex>
          </Flex>
          <PassesListFilter isOpen={isOpen} onOpen={onOpen} onClose={onClose} />
        </Box>
      )}
    </>
  );
}

export default PassesListHeader;
